import {
  NonprofitAdminPageState,
  NonprofitAdminPageContextAction,
  NonprofitAdminPageContextActionType,
} from "src/context/NonprofitAdminPageContext/types";

export const nonprofitAdminPageReducer = (
  state: NonprofitAdminPageState,
  action: NonprofitAdminPageContextAction
): NonprofitAdminPageState => {
  switch (action.type) {
    case NonprofitAdminPageContextActionType.SHOW_SIDEBAR:
      return {
        ...state,
        sidebar: {
          ...state.sidebar,
          visible: true,
        },
      };
    case NonprofitAdminPageContextActionType.HIDE_SIDEBAR:
      return {
        ...state,
        sidebar: {
          ...state.sidebar,
          visible: false,
        },
      };
    case NonprofitAdminPageContextActionType.TOGGLE_SIDEBAR:
      return {
        ...state,
        sidebar: {
          ...state.sidebar,
          visible: !state.sidebar.visible,
        },
      };
    case NonprofitAdminPageContextActionType.ENABLE_SIDEBAR:
      return {
        ...state,
        sidebar: {
          ...state.sidebar,
          enabled: true,
        },
      };
    case NonprofitAdminPageContextActionType.DISABLE_SIDEBAR:
      return {
        ...state,
        sidebar: {
          ...state.sidebar,
          enabled: false,
        },
      };
    case NonprofitAdminPageContextActionType.FETCH_DONATION_FLOW_CUSTOMIZATION_START:
      return {
        ...state,
        donationFlowCustomization: {
          ...state.donationFlowCustomization,
          loading: true,
          errorMessage: null,
        },
      };
    case NonprofitAdminPageContextActionType.FETCH_DONATION_FLOW_CUSTOMIZATION_SUCCESS:
      return {
        ...state,
        donationFlowCustomization: {
          loading: false,
          saving: false,
          hasNoExistingCustomization: action.customization === null,
          errorMessage: null,
          value: action.customization,
        },
      };
    case NonprofitAdminPageContextActionType.FETCH_DONATION_FLOW_CUSTOMIZATION_ERROR:
      return {
        ...state,
        donationFlowCustomization: {
          ...state.donationFlowCustomization,
          loading: false,
          errorMessage: action.errorMessage,
        },
      };
    case NonprofitAdminPageContextActionType.SAVE_DONATION_FLOW_CUSTOMIZATION_START:
      return {
        ...state,
        donationFlowCustomization: {
          ...state.donationFlowCustomization,
          saving: true,
          errorMessage: null,
        },
      };
    case NonprofitAdminPageContextActionType.SAVE_DONATION_FLOW_CUSTOMIZATION_SUCCESS:
      return {
        ...state,
        donationFlowCustomization: {
          loading: false,
          saving: false,
          hasNoExistingCustomization: false,
          errorMessage: null,
          value: action.customization,
        },
      };
    case NonprofitAdminPageContextActionType.SAVE_DONATION_FLOW_CUSTOMIZATION_ERROR:
      return {
        ...state,
        donationFlowCustomization: {
          ...state.donationFlowCustomization,
          saving: false,
          errorMessage: action.errorMessage,
        },
      };
    default:
      return state;
  }
};
